<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import SensorPreview from 'src/components/TemperatureScheme/TempSchemeDrawSections/SensorPreview.svelte';
	import ActuatorsPreview from 'src/components/TemperatureScheme/TempSchemeDrawSections/ActuatorsPreview.svelte';

	export let deviceSensorId: string;
	export let deviceSensor: any;
	export let deviceSensorIsOnline: boolean;
	export let extTempSensor: any;
	export let extTempSensorValue: any;
	export let actuators: any[];

	// Accept unused props forwarded from parent without Svelte warnings
	export let id;
	export let units;
	export let thermostatDefTemp;
	export let type;
</script>

<SidepanelContent>
	<SensorPreview
		device={deviceSensor || { id: deviceSensorId, deleted: true }}
		extSensor={extTempSensor}
		extSensorValue={extTempSensorValue}
		sensorIsOnline={Boolean(deviceSensorIsOnline)}
	/>
	<ActuatorsPreview {actuators} />
</SidepanelContent>
